/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ContextMenu, SVGIcon } from '@ba/ba-ui-carbon-toolkit';

import './ContextMenuIcon.scss';

@observer
class ContextMenuIcon extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const { iconId } = this.props;

		return (
			<div
				className="explore__contextMenu-anchor"
				onClick={(event) => this.handleClick(event)}
				onTouchEnd={(event) => this.handleClick(event)}
			>
				<SVGIcon
					className="context-menu"
					iconId={iconId}
				/>
				{this.renderContextMenu()}
			</div>
		);
	}

	renderContextMenu() {
		const { placement = 'right', items, children } = this.props;

		if (!items || !items.length) {
			return;
		}

		return (
			<ContextMenu
				theme={true}
				placement={placement}
				domNodeToAttachTo={document.body}
				onClose={this.onClose.bind(this)}
				onChange={this.onChange.bind(this)}
			>
				{/* Allow items to be passed in, or as children  */}
				{this.renderItems(items)}
				{children}
			</ContextMenu>
		);
	}

	renderItems(items) {
		if (items) {
			return items.map((section, index) => this.renderSection(section, index));
		}
	}

	renderSection(section, key) {
		if (Array.isArray(section.items)) {
			const { name = 'menu', label, items } = section;

			return <ContextMenu.List key={key} content={items} name={name} label={label} clickSelection={true} />;
		} else {
			return <ContextMenu.Separator key={key} />;
		}
	}

	onChange(name, value) {
		const event = {};
		event[name] = value;

		this.props.onChange(event);
	}

	handleClick(event) {
		this.onToggle();
		// Prevents the mouse up event when touch event happens
		event.preventDefault();
	}

	onToggle() {
		const toggle = !(this.props.items && this.props.items.length);

		this.props.onToggle(toggle);
	}

	onClose() {
		this.props.onToggle(false);
	}
}

ContextMenuIcon.propTypes = {
	iconId: PropTypes.string.isRequired,
	items: PropTypes.array,
	children: PropTypes.any,
	placement: PropTypes.string,
	onChange: PropTypes.func,
	onToggle: PropTypes.func
};

ContextMenuIcon.defaultProps = {
	items: [],
	onChange: () => {},
	onToggle: () => {}
};

export default ContextMenuIcon;



// WEBPACK FOOTER //
// ./src/js/components/contextMenu/ContextMenuIcon.js